export const BANNER_SUCCESS = "BANNER_SUCCESS";
export const BANNER_FAIL = "BANNER_FAIL";
